import { useToast } from 'primevue/usetoast';

export const useToastNotification = ({ message = '', isSuccess = true }) => {
  const toast = useToast();

  const showNotification = () => {
    toast.add({
      severity: isSuccess ? 'success' : 'error',
      summary: isSuccess ? 'Success' : 'Error',
      detail: message,
      life: 3000,
    });
  };

  showNotification();
};
